import { SignJWT } from "jose"

//make token from jwt
const secretKey = new TextEncoder().encode(process.env.REACT_APP_JWT_SECRET) // Replace with your actual secret key

const getToken = async userdata => {
  const token = await new SignJWT(userdata)
    .setProtectedHeader({ alg: "HS256" })
    .setExpirationTime("1h")
    .sign(secretKey)

  return token
}

export default getToken
